
  export default {
      props:{
          cart:{default:{}}
      },
      data() {
          return {
              donationAmounts: [0, 1, 2, 3, 10]
          }
      },
      methods:{
          async selectDonation(amount) {
              this.cart.donation = amount;
              await this.$hyperCart.saveCart(this.cart);
          },
      },
  }
  